import { render, staticRenderFns } from "./TableauDestinataires.vue?vue&type=template&id=6abff016&scoped=true&"
import script from "./TableauDestinataires.js?vue&type=script&lang=js&"
export * from "./TableauDestinataires.js?vue&type=script&lang=js&"
import style0 from "./TableauDestinataires.scoped.scss?vue&type=style&index=0&id=6abff016&lang=scss&scoped=true&"
import style1 from "./TableauDestinataires.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abff016",
  null
  
)

export default component.exports